namespace Matrix.Data {
    export interface ClientFieldForm {
        FieldName: Serenity.StringEditor;
        Expression: Serenity.StringEditor;
        PropertyName: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        DataType: ClientFieldDataTypeEditor;
        DataPrecision: Serenity.IntegerEditor;
        DataScale: Serenity.IntegerEditor;
        SqlDefault: Serenity.StringEditor;
        PrimaryKey: Serenity.BooleanEditor;
        LookupInclude: Serenity.BooleanEditor;
        IsNotNull: Serenity.BooleanEditor;
        IsRequired: Serenity.YesNoCheckEditor;
        Insertable: Serenity.BooleanEditor;
        Updatable: Serenity.BooleanEditor;
        Cloneable: Serenity.BooleanEditor;
        Identity: Serenity.BooleanEditor;
        FilterOnly: Serenity.BooleanEditor;
        ForeignTable: Serenity.StringEditor;
        ForeignField: Serenity.StringEditor;
        JoinAlias: Serenity.StringEditor;
        VisibleInForm: Serenity.BooleanEditor;
        FormTab: Serenity.StringEditor;
        FormCategory: Serenity.StringEditor;
        FormWidth: FormWidthEditor;
        FormWidthUntilNext: Serenity.BooleanEditor;
        FormWidthJustThis: Serenity.BooleanEditor;
        LabelWidth: Serenity.StringEditor;
        LabelWidthUntilNext: Serenity.BooleanEditor;
        LabelWidthJustThis: Serenity.BooleanEditor;
        DefaultValue: Serenity.StringEditor;
        MaxLength: Serenity.IntegerEditor;
        DecimalPlaces: Serenity.IntegerEditor;
        DateTimeKind: Serenity.EnumEditor;
        EditorType: Serenity.LookupEditor;
        VisibleInGrid: Serenity.BooleanEditor;
        EditLink: Serenity.BooleanEditor;
        Width: Serenity.IntegerEditor;
        Alignment: AlignmentStringEditor;
        QuickSearchType: Serenity.EnumEditor;
        DisplayFormat: Serenity.StringEditor;
        FormatterType: Serenity.LookupEditor;
        SortOrder: Serenity.IntegerEditor;
        GroupOrder: Serenity.IntegerEditor;
        DisplayOrder: Serenity.IntegerEditor;
        SummaryType: Serenity.IntegerEditor;
        ReadPermission: Serenity.StringEditor;
        ModifyPermission: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ClientFieldForm extends Serenity.PrefixedContext {
        static formKey = 'Data.ClientField';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ClientFieldForm.init)  {
                ClientFieldForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = ClientFieldDataTypeEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.YesNoCheckEditor;
                var w5 = FormWidthEditor;
                var w6 = s.EnumEditor;
                var w7 = s.LookupEditor;
                var w8 = AlignmentStringEditor;
                var w9 = StaticTextBlock;
                var w10 = ReadOnlyDateTime;

                Q.initFormType(ClientFieldForm, [
                    'FieldName', w0,
                    'Expression', w0,
                    'PropertyName', w0,
                    'DisplayName', w0,
                    'DataType', w1,
                    'DataPrecision', w2,
                    'DataScale', w2,
                    'SqlDefault', w0,
                    'PrimaryKey', w3,
                    'LookupInclude', w3,
                    'IsNotNull', w3,
                    'IsRequired', w4,
                    'Insertable', w3,
                    'Updatable', w3,
                    'Cloneable', w3,
                    'Identity', w3,
                    'FilterOnly', w3,
                    'ForeignTable', w0,
                    'ForeignField', w0,
                    'JoinAlias', w0,
                    'VisibleInForm', w3,
                    'FormTab', w0,
                    'FormCategory', w0,
                    'FormWidth', w5,
                    'FormWidthUntilNext', w3,
                    'FormWidthJustThis', w3,
                    'LabelWidth', w0,
                    'LabelWidthUntilNext', w3,
                    'LabelWidthJustThis', w3,
                    'DefaultValue', w0,
                    'MaxLength', w2,
                    'DecimalPlaces', w2,
                    'DateTimeKind', w6,
                    'EditorType', w7,
                    'VisibleInGrid', w3,
                    'EditLink', w3,
                    'Width', w2,
                    'Alignment', w8,
                    'QuickSearchType', w6,
                    'DisplayFormat', w0,
                    'FormatterType', w7,
                    'SortOrder', w2,
                    'GroupOrder', w2,
                    'DisplayOrder', w2,
                    'SummaryType', w2,
                    'ReadPermission', w0,
                    'ModifyPermission', w0,
                    'CreatedBy', w9,
                    'CreatedWhen', w10,
                    'UpdatedBy', w9,
                    'UpdatedWhen', w10,
                    'Version', w9
                ]);
            }
        }
    }
}
